import AuthClient from 'clients/AuthClient';
import { isValid } from 'clients/Clients';
import { REMEMBER_ME } from 'constants/Cookies';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN, ACCESS_TOKEN_LONGLIVE, GENERAL_DOMAIN } from 'sysconfig';

export function setAuthCookies(info, rememberMe = false) {
  const { bearerToken = null } = info;
  Cookies.set(ACCESS_TOKEN, bearerToken, {
    domain: GENERAL_DOMAIN,
    sameSite: 'Lax',
  });
  Cookies.set(REMEMBER_ME, rememberMe, {
    domain: GENERAL_DOMAIN,
    sameSite: 'Lax',
  });
  if (rememberMe) {
    Cookies.set(ACCESS_TOKEN_LONGLIVE, bearerToken, {
      expires: 5000,
      domain: GENERAL_DOMAIN,
      sameSite: 'Lax',
    });
  }
}

export async function login({
  username,
  password,
  type = 'CUSTOMER',
  refUrl,
  redirectUrl,
  requestOTP,
  otp,
  requestOTPv2 = false,
  secretKey,
  partnerName,
  identityId,
}) {
  const authRes = await AuthClient.login({
    username,
    password,
    type,
    refUrl,
    redirectUrl,
    requestOTP,
    otp,
    requestOTPv2,
    secretKey,
    partnerName,
    identityId,
  });
  if (!isValid(authRes)) {
    return authRes;
  }
  return authRes;
}

export async function signUp(data) {
  const signUpRes = await AuthClient.signUp(data);
  return signUpRes;
}

export async function registerGuest(data) {
  const registerGuestRes = await AuthClient.registerGuest(data);
  return registerGuestRes;
}

export async function loginv1({ tokenv1 }) {
  const registerUserV1 = await AuthClient.registerV1({ t: tokenv1 });
  return registerUserV1;
}

export async function passwordRecovery(data) {
  const passwordRecoveryRes = await AuthClient.passwordRecovery(data);
  return passwordRecoveryRes;
}

export async function passwordUpdate(data) {
  const passwordUpdateRes = await AuthClient.passwordUpdate(data);
  return passwordUpdateRes;
}

export async function newPWUpdate(data) {
  const newPWUpdateRes = await AuthClient.newPassword(data);
  return newPWUpdateRes;
}

export async function verifyPartnerKIOTVIET(data) {
  const verifyPartnerKIOTVIETRes = await AuthClient.verifyPartnerKIOTVIET(data);
  return verifyPartnerKIOTVIETRes;
}

export async function checkMappingKiotvietIDWithBuymedID(data) {
  const newData = { ...data };
  delete newData.accountId;
  const checkMappingKiotvietIDWithBuymedIDRes = await AuthClient.checkMappingKiotvietIDWithBuymedID(newData);
  return checkMappingKiotvietIDWithBuymedIDRes;
}

export async function createMappingPartnerKiotvietFromBuymedID(data) {
  const createMappingPartnerKiotvietFromBuymedIDRes = await AuthClient.createMappingPartnerKiotvietFromBuymedID(data);
  return createMappingPartnerKiotvietFromBuymedIDRes;
}

export async function autoLogin(data) {
  const autoLoginRes = await AuthClient.autoLogin(data);
  return autoLoginRes;
}

export async function getCallbackUrlPartnerKiotviet(data) {
  const loginPartnerRes = await AuthClient.getCallbackUrlPartnerKiotviet(data);
  return loginPartnerRes;
}

export async function getRedirectUrlPartnerKiotviet(data) {
  const redirectUrlRes = await AuthClient.getRedirectUrlPartnerKiotviet(data);
  return redirectUrlRes;
}

export async function accountReferenceKiotviet(data) {
  const accountReferenceKiotvietRes = await AuthClient.accountReferenceKiotviet(data);
  return accountReferenceKiotvietRes;
}

export default {
  login,
  loginv1,
  signUp,
  registerGuest,
  passwordRecovery,
  passwordUpdate,
  newPWUpdate,
  verifyPartnerKIOTVIET,
  checkMappingKiotvietIDWithBuymedID,
  createMappingPartnerKiotvietFromBuymedID,
  autoLogin,
  getCallbackUrlPartnerKiotviet,
  getRedirectUrlPartnerKiotviet,
  accountReferenceKiotviet,
};
